import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    CommandContribution,
    CommandRegistry,
} from '@patsnap/tahiti-core';
import type {
    PricingDialogResult,
} from '@/presentation/components/pricing/PricingDialog.vue';
import { pricingDialogServiceFactory } from '../pricing-dialog.service';
import { PRICING_CONFIG } from '../pricing-config';

/**
 * Pricing 对话框命令处理器
 */
@injectable()
export class PricingDialogCommandHandler implements CommandContribution {
    private _dialogService = pricingDialogServiceFactory();

    /**
     * 处理打开价格卡片对话框命令
     */
    private async _handleOpenPricingDialog(payload?: { title?: string }): Promise<PricingDialogResult> {
        return new Promise((resolve, reject) => {
            const dialog = this._dialogService;

            // 设置提交回调
            dialog.onSubmit(async (result, next) => {
                try {
                    // 可以在这里添加提交后的处理逻辑
                    // 例如：埋点、数据分析等
                    console.log('Pricing dialog submitted:', result);
                    resolve(result);
                    next(); // 关闭对话框
                } catch (error) {
                    next(false); // 保持对话框打开
                    reject(error);
                }
            });

            // 设置取消回调
            dialog.onCancel(() => {
                const result: PricingDialogResult = {
                    action: 'cancel',
                };
                resolve(result);
            });

            // 打开对话框，使用配置文件的默认值
            dialog.open({
                title: payload?.title,
                width: PRICING_CONFIG.DEFAULT_WIDTH,
                height: PRICING_CONFIG.DEFAULT_HEIGHT,
                showCloseButton: true,
            });
        });
    }

    /**
     * 注册命令
     */
    registerCommands(commands: CommandRegistry): void {
        // 注册打开价格卡片对话框命令
        commands.registerCommand({
            id: 'pricing:open-dialog',
        }, {
            execute: (payload?: { title?: string }) => {
                return this._handleOpenPricingDialog(payload);
            },
        });
    }
}

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开升级对话框
         * @param commandId - 命令(打开升级对话框)
         * @param params - 参数(包含查询参数)
         */
        executeCommand(commandId: 'pricing:open-dialog', params?: any): void;
    }
}
